import React from "react";

const Gift = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M4 9.5h9.375v3.75H4V9.5zM4 15.125h9.375V28.25H4V15.125zM22.75 9.5h9.375v3.75H22.75V9.5zM22.75 28.25h9.375V15.125H22.75V28.25zm1.875-5.625h5.625V24.5h-5.625v-1.875z"
            fill={fill}
      />
      <path className="u_fill"
          d="M23.629 6.96a2.806 2.806 0 00.996-2.147A2.816 2.816 0 0021.812 2a2.8 2.8 0 00-2.68 1.963l-1.07 3.373-1.069-3.373A2.8 2.8 0 0014.313 2 2.816 2.816 0 0011.5 4.813c0 .829.363 1.612.998 2.148L15.5 9.5h-.251V34l2.813-2.813L20.875 34V9.5h-.25l3.004-2.54zm-2.71-2.431a.939.939 0 111.5 1l-2.482 2.096.982-3.096zm-7.544.284a.939.939 0 011.831-.284l.982 3.096-2.48-2.095a.938.938 0 01-.333-.718z"
            fill={fill}
      />
    </svg>
);

export default Gift;
